import PropTypes from 'prop-types';
import React from 'react';
import _ from 'underscore';

const SmallVehicleIcon = ({
  color,
}) => {
  const dropshadowId = _.uniqueId('dropshadow');
  const contrast = '#ffffff';
  return (
    <svg
      width="20px"
      height="20px"
      viewBox="-5 -5 22 22"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <filter id={dropshadowId} y="-40%" height="180%" x="-40%" width="180%">
        <feOffset dx="1" dy="1" in="SourceAlpha" result="offset1" />
        <feGaussianBlur stdDeviation="2" in="offset1" result="blur1" />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
          in="blur1"
          result="matrix1"
        />
        <feMerge>
          <feMergeNode in="matrix1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <g
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        style={{filter: `url(#${dropshadowId})`}}
      >
        <g stroke={contrast} strokeWidth="2" fill={color}>
          <circle stroke={contrast} strokeWidth="2" fill={color} cx="5" cy="5" r="7" />
          <circle fill={contrast} cx="5" cy="5" r="1.5" />
        </g>
      </g>
    </svg>
  );
};

SmallVehicleIcon.propTypes = {
  color: PropTypes.string.isRequired,
};

export default SmallVehicleIcon;



// WEBPACK FOOTER //
// ./src/common/components/VehicleOverlayMarker/SmallVehicleIcon.js